import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-textaligntop",
  "use": "icon-textaligntop-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-textaligntop\"><path d=\"M910.222222 1024V0h113.777778v1024h-113.777778zM455.111111 0h113.777778v512H455.111111V0zM0 0h113.777778v1024H0V0z\" fill=\"#000000\" p-id=\"3930\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol